"use client";

import { useEffect, useMemo, useState } from "react";
import { useSearchParams } from "next/navigation";
import Header from "./Header";
import { PersistentHeaderProvider } from "./PersistentHeaderContext";
import type { Store } from "@/lib/types/stores";

type PersistentHeaderProps = {
  base: string;
  children: React.ReactNode;
};

export default function PersistentHeader({ base, children }: PersistentHeaderProps) {
  const searchParams = useSearchParams();
  const [stores, setStores] = useState<Store[]>([]);

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const res = await fetch(`${base}/api/stores`, { cache: "no-store" });
        if (!res.ok) return;
        const json = await res.json();
        if (active && json?.stores) {
          setStores(json.stores);
        }
      } catch {
        // Keep the global header mounted even if store bootstrap fails.
      }
    })();

    return () => {
      active = false;
    };
  }, [base]);

  const searchQuery = useMemo(() => {
    return searchParams.get("q") || "";
  }, [searchParams]);

  return (
    <PersistentHeaderProvider enabled={true}>
      <Header stores={stores} base={base} searchQuery={searchQuery} persistentRoot />
      {children}
    </PersistentHeaderProvider>
  );
}
